import script from "./PaymentMethodList.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodList.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethodList.vue?vue&type=style&index=0&id=d08d1556&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d08d1556"]])

export default __exports__